import { render, staticRenderFns } from "./People.vue?vue&type=template&id=0479c25c&scoped=true&"
import script from "./People.vue?vue&type=script&lang=ts&"
export * from "./People.vue?vue&type=script&lang=ts&"
import style0 from "./People.vue?vue&type=style&index=0&id=0479c25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0479c25c",
  null
  
)

export default component.exports